<template>
    <header id="header"> 
        <dicta-header :english-supported="true" :showPromotions="'abbreviation'">
            <template slot="endContent">
                <LoginLogout class="hebrew-accounts-component"
                             :menu="menu" 
                             @menu-item-clicked="menuItemClicked"
                             @login-event="reactToLoginEvent"></LoginLogout>
                <user-settings-popup class="hebrew-accounts-component" :tab="tab" ref="user-settings"
                                                                       :allow-downloading="false"
                                                                       :allow-uploading="false"
                                                                       :head-letter-position="2" />
                <!-- note: putting a class on UserSettingsPopup here does not actually work, since its a modal;
                            rather, its ID is hard-coded into the hebrew-accounts-component CSS section below -->
            </template>
        </dicta-header>
        <inner-header 
          :app-name="'abbreviation'"
          :center-left-side="true"
          :title="hebrew ? 'פיענוח ראשי תיבות רבניים' : 'Abbreviations Expander'"
          @logo-clicked="titleOrLogoClicked"
          class="inner-header">
          <template v-slot:logo>
            <img class="d-inline-block" src="../assets/logo.png"  alt=""/>
          </template>
          <template v-slot:show-shortcuts>
            <a id="shortcutsLink" class="show-keyboard-shortcuts" v-bind:class="{'ml-3': hebrew, 'mr-3' : !hebrew}" href="#" @click="showKeyboardShortcutsClicked">
              {{hebrew ? 'קיצורי מקלדת' : 'Keyboard Shortcuts'}}
            </a>
          </template>
          <template v-slot:show-how-to-use>
            <button id="instructionsButton" @click="howToUseClicked" class="btn btn-primary btn-outline-light ">
              {{hebrew ? 'איך זה עובד' : 'How it works'}}
            </button>
          </template>
        </inner-header>
        <b-modal v-model="showGoHomePrompt"
                id="go-home-modal"
                size="sm"
                centered
                hide-header
                :ok-title="hebrew ? 'עבור' : 'Go'"
                :cancel-title="hebrew ? 'ביטול' : 'Cancel'"
                footer-class="go-home-footer"
                @ok="actuallyGoHome">
          <p class="text-center mb-0"
            v-html = "hebrew ? 'במעבר לדף הבית, תאבדו את <br/>הטקסט הקיים' : 'Your data will be erased<br/>if you navigate to the home page'"
          ></p>
          <span class="text-center"><b-form-checkbox v-model="disableGoHomePromptOption">
            {{hebrew ? 'אל תציג שוב' : 'Don\'t show again'}}
          </b-form-checkbox></span>
        </b-modal>
        <how-to-use-popup :show-how-to-use-popup="showHowToUsePopup"/>
        <how-to-use-popup-en :show-how-to-use-popup-en="showHowToUsePopupEn"/>
    </header>
</template>
<script>
import InnerHeader from 'shared/components/InnerHeader/InnerHeader'
import LoginLogout from 'shared/account/components/LoginLogout'
import serviceMixins from '@/mixins/serviceMixins'
import UserSettingsPopup from 'shared/components/account/UserSettingsPopup'
import HowToUsePopup from './HowToUsePopup'
import HowToUsePopupEn from './HowToUsePopupEn'
import {StateSaver} from '@/js/localData'
import {firebaseStore} from 'shared/account/store/firebaseModule'
import {getFolder} from 'shared/dropbox/dropbox_utils'

export default {
  components: {
      InnerHeader,
      LoginLogout,
      UserSettingsPopup,
      HowToUsePopup,
      HowToUsePopupEn
  },
  name: 'headers',
  props: ['globalModesObj'],
  data () {
    return {
     tab: {
        activeTab: 'profile',
        activeSet: 'profile'
      },
      showHowToUsePopup: false,
      showHowToUsePopupEn: false,
      showGoHomePrompt: false,
      disableGoHomePromptOption: null // set when mounting
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    menu () {
      let menuArray = []
      if (this.$store.state.account && this.$store.state.account.isLoggedIn) {
        menuArray.push(
          {title: this.$settings.hebrew ? 'פרופיל אישי' : "User profile", data: 'user-settings', tab: 'profile'},
          {title: this.$settings.hebrew ? 'מאגר אישי' : "Preferred expansions", data: 'user-settings', tab: 'word-list'},
          {title: this.$settings.hebrew ? 'פיענוח פגום' : "Negated expansions", data: 'user-settings', tab: 'negative-word-list'}
        )
        if (this.$store.state.dropbox) // as of now should not really be needed
          menuArray.push({title: this.$settings.hebrew ? 'ניהול פרוייקטים' : 'Project management', data: 'projects'})
      }
      return menuArray
    },
  },
  mixins: [serviceMixins], // for gtag()
  methods: {
    menuItemClicked (menuItem) {
      if (menuItem.data === 'user-settings') this.showUserSettings(menuItem.tab)
      if (menuItem.data === 'projects' && this.$route.name !== 'Projects') {
        const currentPath = this.$store.state.dropbox && this.$store.state.dropbox.status
                            && this.$store.state.dropbox.status.path_display
        this.$router.push('/projects' + (currentPath ? getFolder(currentPath) : ''))
      }
    },
    reactToLoginEvent(loginEventType) {
      if (loginEventType === 'completing') firebaseStore('permissionToUseData', 
        Object.prototype.hasOwnProperty.call(window.localStorage, 'permission-to-use-abbreviation-data') ?
          window.localStorage['permission-to-use-abbreviation-data'] : 'false')
      if (loginEventType === 'logout') this.$store.commit('UPDATE_USER_DICTIONARY', { justEmptyLocalCopy: true })
      StateSaver.saveState(this.$store.state)
    },
    showUserSettings(tab) {
       this.tab.activeTab = tab
       this.tab.activeSet = tab
       this.$refs['user-settings'].$children[0].show() // the $ref is the COMPONENT, $children[0] is the modal
    },
    showKeyboardShortcutsClicked () {
      this.$emit('show-keyboard-shortcuts')
      this.gtag("event", "show popup", {
        'event_category': 'common header',
        'event_label': 'show-shortcuts clicked'
      })
    },
    howToUseClicked () {
      this.gtag("event", "show popup", {
        'event_category': 'common header',
        'event_label': 'how-to-use clicked'
      })
      document.activeElement.blur()
      const HOW_TO_USE_OPENS = { DOCUMENTATION_TAB: false, POPUP: true } // at least temporarily
      if (HOW_TO_USE_OPENS.DOCUMENTATION_TAB) window.open('/documentation')
      if (HOW_TO_USE_OPENS.POPUP) {
        if (this.hebrew)  {
          this.showHowToUsePopup = false // because the modal reacts to CHANGE in showHowToUsePopup
        } else {
          this.showHowToUsePopupEn = false
        }
        setTimeout(() => {
          if (this.hebrew) {
            this.showHowToUsePopup = true
          } else {
             this.showHowToUsePopupEn = true 
          }
        }, 100)
      }
    },
    titleOrLogoClicked () {
      if (this.$route.name === 'text-prep') return
      document.activeElement.blur()
      if (this.$store.state.allWorkingNikud.wordsArray.length 
          && !(this.$store.state.postSubmissionOptions.disableGoHomePrompt)) { 
        this.showGoHomePrompt = true
      } else this.actuallyGoHome()
    },
    actuallyGoHome () {
      this.showGoHomePrompt = false
      if (this.disableGoHomePromptOption) this.$store.commit('SET_DISABLE_GO_HOME_PROMPT', true)
      this.$store.commit('EDIT_DOCUMENT_TEXT', {text: '', nullifySource: true})
      this.globalModesObj.allowLeaving = true
      this.$router.push({ name: 'text-prep' })
    }
  },
  mounted () {
    this.disableGoHomePromptOption = this.$store.state.postSubmissionOptions.disableGoHomePrompt
  }
}
</script>

<style>
.hebrew-accounts-component, #user-settings {
  direction: rtl;
  text-align: right;
}
</style>
<!-- note the above is NOT scoped! -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .inner-header {
    height: 50px;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
    display: flex;
    align-items: center;
  }

  .show-keyboard-shortcuts {
      color: white;
      text-decoration: underline;
  }
</style>
